import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/donations/donors";

export const Route = createFileRoute("/admin/_donations/donors")({
  component: Page,
});
